import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=bdc60c82&"
import script from "./Login.vue?vue&type=script&lang=js&"
export * from "./Login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdc60c82')) {
      api.createRecord('bdc60c82', component.options)
    } else {
      api.reload('bdc60c82', component.options)
    }
    module.hot.accept("./Login.vue?vue&type=template&id=bdc60c82&", function () {
      api.rerender('bdc60c82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/login2/views/Login.vue"
export default component.exports